import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const SettingsSectionColumnsWrapper = styled.div`
  display: flex;
  gap: ${Spacing.S80};
`
